import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { UserProfile } from '../../components/UserProfile';
import {
  STORE_AUTH,
  STORE_NOTIFICATION,
  STORE_VIDEO,
  STORE_SUBSCRIPTION
} from '../../constants';
import { AvatarColour } from '../../models';
import {
  AuthStore,
  NotificationStore,
  VideoStore,
  SubscriptionStore,
  SetupCardFunction
} from '../../stores';
import { AsyncStripeProvider } from '../Utils/AsyncStripeProvider';
import './style.css';

export interface UserProfilePageProps extends RouteComponentProps<{}> {
  /* [STORE_AUTH]: AuthStore; */
  /* [STORE_VIDEO]: VideoStore; */
}

export interface UserProfilePageState {
  /* empty */
}

@inject(STORE_AUTH)
@inject(STORE_NOTIFICATION)
@inject(STORE_SUBSCRIPTION)
@inject(STORE_VIDEO)
@observer
export class UserProfilePage extends React.Component<
  UserProfilePageProps,
  UserProfilePageState
> {
  UNSAFE_componentWillMount() {
    const authStore = this.props[STORE_AUTH] as AuthStore;

    authStore.clearUpdateUserError();
  }

  render() {
    const authStore = this.props[STORE_AUTH] as AuthStore;
    const notificationStore = this.props[
      STORE_NOTIFICATION
    ] as NotificationStore;
    const subscriptionStore = this.props[
      STORE_SUBSCRIPTION
    ] as SubscriptionStore;
    const videoStore = this.props[STORE_VIDEO] as VideoStore;

    return (
      <AsyncStripeProvider
        render={stripeReady => {
          if (!authStore.currentUser) {
            return null;
          }

          return (
            <UserProfile
              cancelMembershipError={subscriptionStore.cancelling.error}
              cardUpdateError={subscriptionStore.cardUpdate.error}
              cardUpdateRequestRunning={subscriptionStore.cardUpdate.running}
              error={authStore.updateUserError}
              favouritesByCategory={videoStore.favouritesByCategory}
              loading={
                !stripeReady ||
                authStore.updateUserInProgress ||
                subscriptionStore.cancelling.running
              }
              onCancelPremium={async () => {
                try {
                  await subscriptionStore.cancelMembership();

                  notificationStore.addNotification({
                    message: `Your premier membership has been successfully cancelled, and will remain usable until the date shown`
                  });
                } catch (ex) {
                  // Errors are handled by flag on store
                }
              }}
              onRequestPremium={() => subscriptionStore.requestSignUp()}
              onSaveProfile={this.updateUser}
              onUpdateCard={async (setupCard: SetupCardFunction) => {
                await subscriptionStore.updateCard(setupCard);

                notificationStore.addNotification({
                  message: `Card details updated successfully!`,
                  duration: 10000
                });
              }}
              user={authStore.currentUser}
            />
          );
        }}
      />
    );
  }

  private updateUser = async (
    name: string,
    colour: AvatarColour,
    password?: string,
    currentPassword?: string
  ) => {
    const authStore = this.props[STORE_AUTH] as AuthStore;
    const notificationStore = this.props[
      STORE_NOTIFICATION
    ] as NotificationStore;

    await authStore.updateUser(name, colour, password, currentPassword);

    if (!authStore.updateUserError) {
      notificationStore.addNotification({
        message: 'Profile updated successfully!'
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/containers/UserProfilePage/index.tsx